import React from 'react'

import { Field } from 'formik'

import { Form, Row, Col } from '_zari/core'

import CalculosDeDepreciacionConstant from 'constants/tiposDeCalculoDeDepreciacion'

const CalculoDeDepreciacionFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label
        text='CALCULO DE DEPRECIACION'
        htmlFor='checkbox-calculoDeDepreciacion'
        md={4}
        alignRightAt='md'
      />
      <Col md={8} className='col-calculoDeDepreciacion'>
        <Row>
          <Col md={12}>
            <Field name='calculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === CalculosDeDepreciacionConstant.MENSUAL}
                  id='radio-mensual'
                  label={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.MENSUAL
                    ].nombre
                  }
                  value={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.MENSUAL
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={12}>
            <Field name='calculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === CalculosDeDepreciacionConstant.ANUAL}
                  id='radio-Anual'
                  label={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.ANUAL
                    ].nombre
                  }
                  value={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.ANUAL
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={12}>
            <Field name='calculoDeDepreciacion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={fIsSubmitting}
                  checked={iValue === CalculosDeDepreciacionConstant.NINGUNO}
                  id='radio-Ninguno'
                  label={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.NINGUNO
                    ].nombre
                  }
                  value={
                    CalculosDeDepreciacionConstant.__dictionary[
                      CalculosDeDepreciacionConstant.NINGUNO
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
        </Row>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CalculoDeDepreciacionFormGroup)
